module.exports = __webpack_public_path__ + "img/slot_slotmachine.cd00ada0.png";